import Api from '~/api'
import { Map, List, fromJS } from 'immutable'
import { serializeFilters } from '../datatable'

export function addListener(id, filters = {}) {
  return async (dispatch, getState) => {
    if (getState().eventLog.has(id)) return

    try {
      dispatch({
        type: 'EVENT_ADD_LISTENER',
        id,
        filters,
      })

      let { data } = await Api.get('/datatable', {
        entity: 'event',
        filters: serializeFilters(filters),
        sortDir: 'desc',
        sortBy: 'created_at',
        limit: 100,
      })

      if (!data.success) throw Error(data.message)

      dispatch({
        type: 'EVENT_LOG_INIT',
        id,
        data,
      })
    } catch (err) {
      console.log(err)
      dispatch({
        type: 'EVENT_LOG_ERROR',
        id,
        message: err.message || 'Error when getting log',
      })
    }
  }
}

export function removeListener(id) {
  return {
    type: 'EVENT_REMOVE_LISTENER',
    id,
  }
}

export function registerEvents(events = false) {
  if (!Array.isArray(events)) return null

  return {
    type: 'EVENT_PUSH',
    events: fromJS(events),
  }
}

export function createNote(id, value, relations) {
  return async (dispatch, getState) => {
    try {
      dispatch({
        type: 'EVENT_CREATE_NOTE_SAVING',
        id,
        saving: true,
      })

      let { data } = await Api.post('/event/note', {
        value,
        relations,
      })

      if (!data.success) throw Error(data.message)

      dispatch({
        type: 'EVENT_CREATE_NOTE_SUCCESS',
        id,
        events: fromJS(data.events || []),
      })
    } catch (err) {
      console.log(err)
      dispatch({
        type: 'EVENT_CREATE_NOTE_ERROR',
        id,
        message: err.message || 'Error when getting log',
      })
    }
  }
}
